import React from 'react'
import {
  Button,
  PopoverHeader,
  UncontrolledPopover
} from 'reactstrap'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import projectUnusedStringsActions from './actions'

const ProjectStringToRemoveRow = ({
  destroyingError = null,
  destroyingId = null,
  destroyingStatus = 'idle',
  dispatch,
  project = null,
  projectString: {
    id,
    key,
    locale,
    path,
    value
  }
}) => {
  const { t } = useTranslation(['ProjectsPage', 'commons'])

  const onRemoveClick = () => {
    dispatch(
      projectUnusedStringsActions.destroy(project.id, locale, id)
    )
  }

  const displayValue = (val) => {
    if (val === null || val === undefined) return ''
    if (typeof val === 'object') return JSON.stringify(val)
    return String(val)
  }

  return (
    <tr>
      <td>{key}</td>
      <td>{path}</td>
      <td>{locale}</td>
      <td>{displayValue(value)}</td>
      <td>
        <Button
          color="danger"
          id={`unused-string-delete-${id}`}
          onClick={() => onRemoveClick()}
          type="submit"
        >
          {t('buttons.remove', { ns: 'commons' })}
        </Button>

        <UncontrolledPopover
          isOpen={destroyingStatus === 'failed' && destroyingId === id}
          placement="left"
          target={`unused-string-delete-${id}`}
          trigger="legacy"
        >
          <PopoverHeader className="border-0 bg-danger text-white">
            {t('ProjectUnusedStrings.ProjectStringToRemoveRow.errorPopover.title')}
            &nbsp;:&nbsp;
            {destroyingError}
          </PopoverHeader>
        </UncontrolledPopover>
      </td>
    </tr>
  )
}

ProjectStringToRemoveRow.propTypes = {
  destroyingError: PropTypes.string,
  destroyingId: PropTypes.string,
  destroyingStatus: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  projectString: PropTypes.shape({
    key: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    locale: PropTypes.string,
    path: PropTypes.string.isRequired,
    value: PropTypes.string
  }).isRequired
}

const mapStateToProps = ({
  projects: {
    item: project
  },
  projectUnusedStrings: {
    destroyingError,
    destroyingId,
    destroyingStatus
  }
}) => ({
  destroyingError,
  destroyingId,
  destroyingStatus,
  project
})

export default connect(mapStateToProps)(ProjectStringToRemoveRow)
